<template>
  <div>
    <b-card :title="cardTitle">
      <b-row class="d-flex justify-content-center align-items-center">
        <b-col>
          <b-form-group
            label="Ay"
            label-for="month"
          >
            <v-select
              v-model="ratesParams.month"
              :options="months"
              label="title"
              :reduce="item => item.id"
              @input="getReportData"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Yıl"
            label-for="year"
          >
            <v-select
              v-model="ratesParams.year"
              :options="years"
              label="title"
              :reduce="item => item.id"
              @input="getReportData"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BCol, BFormGroup, BRow, BCard,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'SwapsFilter',
  components: {
    BFormGroup, BCol, BRow, BCard, vSelect,
  },
  props: {
    cardTitle: {
      type: String,
      default: null,
    },
    getReportData: {
      type: Function,
      required: true,
    },
  },
  computed: {
    months() {
      return this.$store.getters['saleGoalsReports/months']
    },
    years() {
      return this.$store.getters['saleGoalsReports/years']
    },
    ratesParams() {
      return this.$store.getters['saleGoalsReports/ratesParams']
    },
  },
  created() {
    this.getParams()
  },
  methods: {
    getParams() {
      this.$store.dispatch('saleGoalsReports/getParams')
    },
  },
}
</script>
